import { useDataProvider } from "react-admin";

import { AppResource } from "~/config/resources";
import { MerchantDataProvider } from "./merchantDataProvider";

export const useMerchantDataProvider = (): [
  AppResource,
  MerchantDataProvider,
] => [AppResource.Merchant, useDataProvider<MerchantDataProvider>()];
